module.exports = __webpack_public_path__ + "static/media/mevr.777b58bb.png";